export function getDocumentLink(response) {
  if (!response) return null;

  return (
    response.metadata?.documentLink ||
    response.documentLink ||
    response.data?.data?.metadata?.documentLink ||
    response.data?.data?.documentLink
  );
}

export function getDriveItemId(response) {
  if (!response) return null;
  return (
    response.metadata?.driveItemId ||
    response.driveItemId ||
    response.data?.data?.metadata?.driveItemId ||
    response.data?.data?.driveItemId
  );
}

export function getFileType(response) {
  if (!response) return null;
  return response.metadata?.fileType || response.data?.data?.metadata?.fileType || "docx";
}

export function getIsCompared(response) {
  if (!response) return null;

  if (response.metadata && "isCompared" in response.metadata) {
    return response.metadata.isCompared;
  }

  if ("isCompared" in response) {
    return response.isCompared;
  }

  if (response.data?.data?.metadata && "isCompared" in response.data.data.metadata) {
    return response.data.data.metadata.isCompared;
  }

  if (response.data?.data && "isCompared" in response.data.data) {
    return response.data.data.isCompared;
  }

  return null;
}

export function getIsRedlined(response) {
  if (!response) return null;

  if (response.metadata && "isRedlined" in response.metadata) {
    return response.metadata.isRedlined;
  }

  if ("isRedlined" in response) {
    return response.isRedlined;
  }

  if (response.data?.data?.metadata && "isRedlined" in response.data.data.metadata) {
    return response.data.data.metadata.isRedlined;
  }

  if (response.data?.data && "isRedlined" in response.data.data) {
    return response.data.data.isRedlined;
  }

  return null;
}

export function getPdfUrl(response) {
  if (!response) return null;

  return response.pdfDetails?.url || response.attachment?.documentLink;
}

export function getDocumentDetails(response, cleanMeta, includePdf, documentId) {
  if (!response) return null;

  // legacy format
  if ("pdfDetails" in response) {
    return {
      documentId,
      driveItemId: getDriveItemId(response),
      fileType: getFileType(response),
      attachment: {
        includePDF: includePdf,
        cleanMeta,
      },
    };
  }

  // new format
  if ("attachment" in response) {
    return {
      documentId,
      driveItemId: getDriveItemId(response),
      fileType: getFileType(response),
      cleanMeta,
      attachment: includePdf ? { driveItemId: response.attachment?.driveItemId } : undefined,
    };
  }

  return null;
}
